import { render, staticRenderFns } from "./Border.vue?vue&type=template&id=3fc358f3"
import script from "./Border.vue?vue&type=script&lang=js"
export * from "./Border.vue?vue&type=script&lang=js"
import style0 from "./Border.vue?vue&type=style&index=0&id=3fc358f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports